import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  //inject services
  constructor(private mds: MetaService) { }

  //initialize component
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale.com - Contact Us';
    var description = 'Contact us today to learn more about how RegScale can transform your compliance processes';
    var keywords = 'RegScale, RegScale, contact us, phone, email, office address';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
